<template>
	<JBox>
		<!-- ###################### -->
		<!-- Normal Layout -->
		<!-- ###################### -->
		<JBox class="s-px-8">
			<JBox class="s-bg-white s-p-6 s-shadow s-rounded-lg s-mt-6 s-max-w-5xl s-mx-auto">
				<JBox>
					<CCodeEditor language="json" :value="value" @input="$emit('input', $event)" />
				</JBox>
				<JFlex class="s-mt-4 s-justify-between">
					<JButton variant="white-sm" @click="layout = 'fullscreen'">Fullscreen mode</JButton>
					<JButton variant="white-sm" @click="formatJson">Format</JButton>
				</JFlex>
			</JBox>
		</JBox>

		<!-- ###################### -->
		<!-- Fullscreen Layout -->
		<!-- ###################### -->
		<JBox v-if="layout === 'fullscreen'" class="s-w-screen s-h-screen s-overflow-y-hidden s-fixed s-top-0 s-left-0 s-bg-white">
			<CCodeEditor language="json" :value="value" @input="$emit('input', $event)" height="100vh" />

			<!-- Close -->
			<JFlex
				class="s-fixed s-top-4 s-right-4 s-w-9 s-h-9 s-bg-gray-100 s-rounded-full s-items-center s-justify-center s-cursor-pointer s-mr-2"
				@click="layout = 'normal'"
			>
				<CIcon name="x" class="s-w-4 s-h-4 s-text-gray-500 s-fill-current" />
			</JFlex>
		</JBox>
	</JBox>
</template>

<script>
export default {
	props: {
		// json logic
		value: {
			type: String
		}
	},

	data() {
		return {
			layout: "normal" // normal, fullscreen
		}
	},

	methods: {
		formatJson() {
			let output
			try {
				output = JSON.stringify(JSON.parse(this.value), null, 2)
			} catch (e) {
				return
			}

			this.$emit("input", output)
		}
	}
}
</script>
